/**
 * Metal swatches on product cards.
 *
 * Clicking a swatch previews that metal in the card and retargets the card's links to
 * that variant, so the shopper lands on the metal they picked instead of the product's
 * default. Delegated from the document because the collection grid, search results and
 * the filter bar all replace their markup via the Section Rendering API — a listener
 * bound per card would be dropped on the first filter change.
 */
(function () {
  'use strict';

  var WIDTHS = [200, 300, 400, 600, 800];

  /** Shopify CDN URLs carry the size as a width= param, so one URL yields the whole set. */
  function srcsetFrom(url) {
    if (!url || url.indexOf('width=') === -1) return '';
    return WIDTHS.map(function (w) {
      return url.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  function withVariant(baseUrl, id) {
    if (!baseUrl || !id) return baseUrl;
    return baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + id;
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.pc-sw');
    if (!sw) return;

    var card = sw.closest('.product-card');
    if (!card) return;

    // The swatch sits inside the card but outside its <a>; stop it anyway in case a
    // future layout nests them.
    e.preventDefault();
    e.stopPropagation();

    var vid = sw.getAttribute('data-vid');
    var img = sw.getAttribute('data-img');

    card.querySelectorAll('.pc-sw').forEach(function (s) {
      var on = s === sw;
      s.classList.toggle('is-selected', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var hero = card.querySelector('[data-pc-hero]');
    if (hero && img) {
      // Keep the pre-swap shot so a card whose variant has no image can fall back to it.
      if (!hero.dataset.pcDefault) {
        hero.dataset.pcDefault = hero.getAttribute('src') || '';
        hero.dataset.pcDefaultSrcset = hero.getAttribute('srcset') || '';
      }
      hero.setAttribute('src', img);
      var ss = srcsetFrom(img);
      if (ss) hero.setAttribute('srcset', ss);
      else hero.removeAttribute('srcset');
      // The hover video/second image still shows the default metal, so once a specific
      // metal is on screen the hover swap would contradict it.
      card.classList.add('pc-picked');
    }

    var base = card.getAttribute('data-pc-url');
    if (base && vid) {
      card.querySelectorAll('[data-pc-link]').forEach(function (a) {
        a.setAttribute('href', withVariant(base, vid));
      });
    }
  });
})();
